import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'

import Badge from 'material-ui/Badge'

import dataActions from 'actions/dataActions'
import tableActions from 'actions/table'

import { currentUserOpenNotifications, unreadedNotifications } from 'selectors/notifications'
import { managers } from 'selectors/entities'
import { notificationsGroups } from 'selectors/notifications'

let select = (state, props) => ({
	currentUserOpenNotifications: currentUserOpenNotifications(state)
  , managers: managers(state)
  , unreadedNotifications: unreadedNotifications(state)
  , notificationsGroups: notificationsGroups(state, props)
})

export class Notifications extends Component {
  render(){
	let { props } = this
    return(
		props.notificationsGroups && props.notificationsGroups.counter>0 ?
			<div
				className="notify-icon-holder"
				style={{cursor: "pointer"}}
				onClick={()=>props.CHOOSE_ITEM(false)}
			>
				<Badge
					badgeContent={props.notificationsGroups && props.notificationsGroups.counter}
					badgeStyle={{top: '15px', right: '0px', background: "red", color: "#fff", fontSize: "12px", width: "20px", height: "20px"}}
					style={{padding: "0"}}
				>
					<i className="material-icons" style={{fontSize: "30px"}}>chat</i>
				</Badge>
    	</div>
		:
		null

    )
  }
}

export default connect(select, R.mergeAll([dataActions, tableActions]))(Notifications)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/Notifications.js